module.exports = __webpack_public_path__ + "images/questions/qa_hero_title_9fdecdd65430c5903ee4c0bd7b381ed4.png";